module.exports = __webpack_public_path__ + "st.svg?c8b75a73c74e95cef2061883039a35a3";